import { useAiAgentEnabled, useAuth, useHasPremiumAccess, useMarketplace, useMasterData, usePermissions } from 'hooks';
import ActivateAccount from 'pages/ActivateAccount';
import { AgreementsSignature } from 'pages/AgreementsSignature';
import Bookings from 'pages/Bookings';
import BusinessSettings from 'pages/BusinessSettings';
import Calendar from 'pages/Calendar';
import Clients from 'pages/Clients';
import GlobalResult from 'pages/GlobalResult';
import Impersonate from 'pages/Impersonate';
import Insights from 'pages/Insights';
import Logout from 'pages/Logout';
import Memberships from 'pages/Memberships';
import MyAccount from 'pages/MyAccount';
import Payments from 'pages/Payments';
import Products from 'pages/Products';
import Services from 'pages/Services';
import { Fragment, FunctionComponent } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
    ActivateAccountPath,
    AgreementsSignaturePath,
    EmailUnsubscribePath,
    BoardingPath,
    TransportationPath,
    TrainingPath,
    WalkingPath,
    //BookingDetailPath,
    //BookingsGroomingPath,
    BookingsPath,
    BookingsRootPath,
    BusinessSettingsPath,
    CalendarPath,
    ClientsEditPath,
    ClientsPath,
    CreationServicePath,
    DaycarePath,
    DiscountsPath,
    ForgotPasswordPath,
    ForgotPasswordSentPath,
    GlobalPath,
    HelpSupportPath,
    ImpersonatePath,
    InsightsPath,
    LoginPath,
    LogoutPath,
    EmailCampaignDetailPath,
    EmailTemplateCreatePath,
    EmailTemplateEditPath,
    MarketingEmailsPath,
    MarketingPath,
    MarketingReviewsPath,
    MarketingLeadsPath,
    MembershipsPath,
    MyAccountPath,
    NewPasswordPath,
    PayByLinkPath,
    PaymentsPath,
    ProductsPath,
    ResetCustomerPath,
    ResetPasswordPath,
    ServicesPath,
    SignUpAlmostPath,
    SignUpBusinessPath,
    SignUpPath,
    SignUpVerifyPath,
    SMSCampaignCreatePath,
    SMSGetStartedPath,
    StaffPath,
    TasksPath,
    TwoWaySMSPath,
    InboxPath,
    UpdateVaccinesPath,
    MarketingPromoCodes,
    MarketingLoyaltyPath,
    MarketingAutomationsPath,
    LeaveReviewPath,
    NotAllowedPath,
    AiAgentPath
} from './Paths';
import PrivateRoute from './PrivateRoute';

import EmailCampaignDetail from 'pages/EmailCampaignDetail';
import EmailTemplateEditor from 'pages/EmailTemplateEditor';
import EmailUnsubscribe from 'pages/EmailUnsubscribe';
import HelpAndSupport from 'pages/HelpCenterSupport';
import MarketingPage from 'pages/Marketing';
import PayByLink from 'pages/PayByLink';
import SMSCampaignCreate from 'pages/SMSCampaignCreate';
import SMSGetStartedPage from 'pages/SMSGetStarted';
import Staff from 'pages/Staff';
import TwoWaySMS from 'pages/TwoWaySMS';
import OmnichannelInbox from 'pages/OmnichannelInbox';
import UpdateVaccines from 'pages/UpdateExpiredVaccines';
import { Login } from 'rocket/pages/Login';
import NewPassword from 'rocket/pages/NewPassword';
import ResetPassword from 'rocket/pages/ResetPassword';
import ResetSent from 'rocket/pages/ResetSent';
import SetPassword from 'rocket/pages/SetPassword';
import SignUp from 'rocket/pages/Signup';
import SignUpAlmost from 'rocket/pages/SignupAlmost';
import SignUpBusiness from 'rocket/pages/SignUpBusiness';
import SignUpVerify from 'rocket/pages/SignupVerify';
import { isMarketingEnabled, isPaymentsEnabled } from 'utils/MarketingUtils';

import TasksLayout from 'components/Tasks/TasksLayout';
import LeaveReview from 'pages/LeaveReview';
import Boarding from 'pages/Boarding';
import Transportation from 'pages/Transportation';
import Training from 'pages/Training';
import Walking from 'pages/Walking';
import Daycare from 'pages/Daycare';
import Discounts from 'pages/Discounts';
import NotAllowed from 'pages/NotAllowed';
import AiAgent from 'pages/AiAgent';

// import TestPage from 'pages/Test';
// const SPIKE_ENV = process.env.REACT_APP_HOST_URL?.toLowerCase() === 'https://spike-api.versiondos.com';

export const Routes: FunctionComponent = () => {
    const auth = useAuth();
    const marketplace = useMarketplace();
    const hasInsightsPremiumAccess = useHasPremiumAccess('insights');
    const hasTwoWaySMSPremiumAccess = useHasPremiumAccess('two_way_sms');
    const permissions = usePermissions();

    const marketingEnabled = isMarketingEnabled(auth.marketplaceId) && permissions.marketing;
    const twoWaySMSEnabled =
        process.env.REACT_APP_TWO_WAY_SMS_ENABLED?.toLowerCase() === 'true' && permissions.twoWaySms;
    const paymentsEnabled = isPaymentsEnabled(marketplace) && permissions.checkout.manage;

    const bookingsEnabled = permissions.bookings;
    const calendarEnabled = permissions.calendar;
    const clientsEnabled = permissions.clients.manage;
    const staffEnabled = permissions.staff;
    const servicesEnabled = permissions.services;
    const helpEnabled = permissions.help;
    const insightsEnabled = permissions.insights;
    const settingsEnabled = permissions.settings;
    const productsEnabled = permissions.products;
    const aiAgentEnabled = useAiAgentEnabled();
    const membershipsEnabled = true;

    return (
        <Fragment>
            <Switch>
                {/* {SPIKE_ENV && <Route path="/test" component={TestPage} />} */}
                <Route
                    path="/we-are-not-mobile"
                    component={Login}
                />
                <Route
                    path={LoginPath}
                    component={Login}
                />
                <Route
                    path={ImpersonatePath}
                    component={Impersonate}
                />
                <Route
                    path={LogoutPath}
                    component={Logout}
                />
                <Route
                    path={ForgotPasswordPath}
                    component={ResetPassword}
                />
                <Route
                    path={ForgotPasswordSentPath}
                    component={ResetSent}
                />
                <Route
                    path={ResetPasswordPath}
                    component={SetPassword}
                />
                <Route
                    path={NewPasswordPath}
                    component={NewPassword}
                />
                <Route
                    path={ResetCustomerPath}
                    component={SetPassword}
                />
                <Route
                    strict
                    exact
                    path={SignUpPath}
                    component={SignUp}
                />
                <Route
                    strict
                    exact
                    path={SignUpAlmostPath}
                    component={SignUpAlmost}
                />
                <Route
                    strict
                    exact
                    path={SignUpBusinessPath}
                    component={SignUpBusiness}
                />
                <Route
                    strict
                    exact
                    path={SignUpVerifyPath}
                    component={SignUpVerify}
                />
                <Route
                    path={ActivateAccountPath}
                    component={ActivateAccount}
                />
                <Route
                    path="/we-are-not-mobile"
                    component={Login}
                />
                <Route
                    path={LoginPath}
                    component={Login}
                />
                <Route
                    path={ImpersonatePath}
                    component={Impersonate}
                />
                <Route
                    path={LogoutPath}
                    component={Logout}
                />
                <Route
                    path={ForgotPasswordPath}
                    component={ResetPassword}
                />
                <Route
                    path={ForgotPasswordSentPath}
                    component={ResetSent}
                />
                <Route
                    path={ResetPasswordPath}
                    component={SetPassword}
                />
                <Route
                    path={NewPasswordPath}
                    component={NewPassword}
                />
                <Route
                    path={ResetCustomerPath}
                    component={SetPassword}
                />
                <Route
                    strict
                    exact
                    path={SignUpPath}
                    component={SignUp}
                />
                <Route
                    strict
                    exact
                    path={SignUpAlmostPath}
                    component={SignUpAlmost}
                />
                <Route
                    strict
                    exact
                    path={SignUpBusinessPath}
                    component={SignUpBusiness}
                />
                <Route
                    strict
                    exact
                    path={SignUpVerifyPath}
                    component={SignUpVerify}
                />
                <Route
                    path={ActivateAccountPath}
                    component={ActivateAccount}
                />

                <Route
                    strict
                    exact
                    path={AgreementsSignaturePath}
                    component={AgreementsSignature}
                />
                <Route
                    strict
                    exact
                    path={AgreementsSignaturePath}
                    component={AgreementsSignature}
                />

                <Route
                    strict
                    exact
                    path={EmailUnsubscribePath}
                    component={EmailUnsubscribe}
                />

                <Route
                    strict
                    exact
                    path={PayByLinkPath}
                    component={PayByLink}
                />

                <Route
                    strict
                    exact
                    path={LeaveReviewPath}
                    component={LeaveReview}
                />

                <Route
                    strict
                    exact
                    path={UpdateVaccinesPath}
                    component={UpdateVaccines}
                />

                <Route
                    strict
                    exact
                    path={DaycarePath}
                    component={Daycare}
                />

                <Route
                    strict
                    exact
                    path={BoardingPath}
                    component={Boarding}
                />

                <Route
                    strict
                    exact
                    path={DiscountsPath}
                    component={Discounts}
                />

                <Route
                    strict
                    exact
                    path={TransportationPath}
                    component={Transportation}
                />

                <Route
                    strict
                    exact
                    path={TrainingPath}
                    component={Training}
                />

                <Route
                    strict
                    exact
                    path={WalkingPath}
                    component={Walking}
                />

                <Route
                    path={TasksPath}
                    component={TasksLayout}
                />

                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingReviewsPath}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={SMSGetStartedPath}
                        component={SMSGetStartedPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={SMSCampaignCreatePath}
                        component={SMSCampaignCreate}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingPromoCodes}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingLoyaltyPath}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingAutomationsPath}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && process.env.REACT_APP_LEADS_ENABLED === 'true' && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingLeadsPath}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingPath}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingEmailsPath}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={EmailTemplateCreatePath}
                        component={EmailTemplateEditor}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={EmailTemplateEditPath}
                        component={EmailTemplateEditor}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={EmailCampaignDetailPath}
                        component={EmailCampaignDetail}
                    />
                )}
                {twoWaySMSEnabled && hasTwoWaySMSPremiumAccess && (
                    <PrivateRoute
                        strict
                        exact
                        path={TwoWaySMSPath}
                        component={TwoWaySMS}
                    />
                )}
                <PrivateRoute
                    strict
                    exact
                    path={InboxPath}
                    component={OmnichannelInbox}
                />

                {!auth.signedIn && <Redirect to={LoginPath} />}
                {auth.signedIn && auth.version !== process.env.REACT_APP_VERSION && <Redirect to={LogoutPath} />}

                {calendarEnabled && (
                    <PrivateRoute
                        path={CalendarPath}
                        component={Calendar}
                    />
                )}
                <PrivateRoute
                    path={GlobalPath}
                    component={GlobalResult}
                />

                {bookingsEnabled && (
                    <PrivateRoute
                        path={[BookingsRootPath, BookingsPath]}
                        component={Bookings}
                    />
                )}
                {servicesEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={CreationServicePath}
                        component={Services}
                    />
                )}
                {servicesEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={ServicesPath}
                        component={Services}
                    />
                )}
                {servicesEnabled && membershipsEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MembershipsPath}
                        component={Memberships}
                    />
                )}
                {clientsEnabled && (
                    <PrivateRoute
                        exact
                        path={ClientsEditPath}
                        component={Clients}
                    />
                )}
                {clientsEnabled && (
                    <PrivateRoute
                        path={ClientsPath}
                        component={Clients}
                    />
                )}

                {staffEnabled && (
                    <PrivateRoute
                        path={StaffPath}
                        component={Staff}
                    />
                )}
                {aiAgentEnabled && (
                    <PrivateRoute
                        path={AiAgentPath}
                        component={AiAgent}
                    />
                )}
                {settingsEnabled && (
                    <PrivateRoute
                        path={BusinessSettingsPath}
                        component={BusinessSettings}
                    />
                )}
                {helpEnabled && (
                    <PrivateRoute
                        path={HelpSupportPath}
                        component={HelpAndSupport}
                    />
                )}
                <PrivateRoute
                    path={MyAccountPath}
                    component={MyAccount}
                />

                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={MarketingPath}
                        component={MarketingPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={SMSGetStartedPath}
                        component={SMSGetStartedPage}
                    />
                )}
                {marketingEnabled && (
                    <PrivateRoute
                        strict
                        exact
                        path={SMSCampaignCreatePath}
                        component={SMSCampaignCreate}
                    />
                )}

                {/* <PrivateRoute strict exact path={NewAgreementsPath} component={AgreementsCreate} />  */}
                {insightsEnabled && (
                    <PrivateRoute
                        path={InsightsPath}
                        component={Insights}
                    />
                )}
                {paymentsEnabled && (
                    <PrivateRoute
                        path={PaymentsPath}
                        component={Payments}
                    />
                )}
                {productsEnabled && (
                    <PrivateRoute
                        path={ProductsPath}
                        component={Products}
                    />
                )}

                <Route
                    strict
                    exact
                    path={NotAllowedPath}
                    component={NotAllowed}
                />

                <Redirect to={bookingsEnabled ? BookingsRootPath : NotAllowedPath} />
            </Switch>
        </Fragment>
    );
};

export default Routes;
